import { Column } from "./columns";
import { Message } from "./message";

export const TemplateConfig = {
  Column,
  Message,
};
